export default {
  mounted: function () {
    if (process.client) {
      ;(function (w) {
        var s = document.createElement("script")
        s.src =
          "//survey.survicate.com/workspaces/62fd30f9c0781924b1dd9eb4b5585de5/web_surveys.js"
        s.async = true
        var e = document.getElementsByTagName("script")[0]
        e.parentNode.insertBefore(s, e)
      })(window)
    }
  },
}
